import React from 'react';
import { useParams } from 'react-router-dom';
import NavbarUni from '../componentes/headUni';
import BodyProductUni from './componenetes/bodyProduct';
import BarCar from '../componentes/barCar';
import Marquee from '../componentes/marquee';

function VerProductUni() {
    const { idCategoria } = useParams(); // Obtener idCategoria de la URL no es id si no nom
    
    return (
        <>
            {/* Contenido de la página */}
            <div>
                <Marquee />
                <NavbarUni />
                <div>
                    <BodyProductUni idCategoria={idCategoria}  />
                </div>
            </div>
        </>
    );
}

export default VerProductUni;
